import { render, staticRenderFns } from "./CPTemp3.vue?vue&type=template&id=5afec27a&scoped=true&"
import script from "./CPTemp3.vue?vue&type=script&lang=js&"
export * from "./CPTemp3.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp3.vue?vue&type=style&index=0&id=5afec27a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afec27a",
  null
  
)

export default component.exports